import * as angular from "angular";
import {IController} from "angular";
import {PlanningCommonService} from "../../services/planning-coomon-service.service";

export class PlanningResourcesTableRowCtrl implements IController {
  resource: any;
  route?: any;
  isSelected: any;
  draft?: any;
  type: any;
  onToggle: Function;
  onView: Function;
  onRemove: Function;
  onCreateARoute: Function;
  onAssignToRoute: Function;
  onAddToDraft: Function;
  onRemoveFromDraft: Function;

  public routeColor: any;

  /* @ngInject */
  constructor(private planningCommonService: PlanningCommonService) {
  }

  $onChanges(onChangesObj: angular.IOnChangesObject) {
    if (onChangesObj.resource) {
      const routeRef = {
        resource: this.resource,
        resourceId: this.resource?.id
      }
      this.routeColor = this.resource.routed ? this.planningCommonService.getRouteColor(routeRef) : undefined;
    }
  }

  getTotalIncomeClass(totalIncome?) {
    const minimumRouteIncome = this.resource.routeIncomePreferences?.minimumRouteIncome || this.draft?.settings?.incomeSettings?.minRouteIncome;
    const maximumRouteIncome = this.resource.routeIncomePreferences?.maximumRouteIncome || this.draft?.settings?.incomeSettings?.maxRouteIncome;
    return (!!minimumRouteIncome && (totalIncome < minimumRouteIncome)) ? 'low' :
      ((!!maximumRouteIncome && (totalIncome > maximumRouteIncome)) ? 'high' : '');
  }

}


angular
  .module('bringoz.admin.planning')
  .component('planningResourcesTableRow', {
    bindings: {
      resource: '<',
      route: '<?',
      draft: '<?',
      isSelected: '<',
      type: '@',
      onToggle: '&',
      onView: '&',
      onRemove: '&',
      onCreateARoute: '&',
      onAssignToRoute: '&',
      onAddToDraft: '&',
      onRemoveFromDraft: '&'
    },
    template: require('./planning-resources-table-row.html').default,
    controller: PlanningResourcesTableRowCtrl
  });
